export const fileQuestions = [
  { id: "1", text: "How many social media account do you have?", answers: [] },
  { id: "2", text: "Do you have a regular job?", answers: ["Yes", "No"] },
  { id: "3", text: "How much do you earn monthly?", answers: [] },
  { id: "4", text: "How much money do you spend on video games?", answers: [] },
  { id: "5", text: "How many hours of Youtube do you watch per week?", answers: [] }
]